export default __webpack_public_path__ + "static/sample-7d8fa75100d3af9a44edc9520e154c94.png";